import React, {useState, useCallback} from 'react';
import {
    Card,
    ResourceList,
    Avatar,
    ResourceItem,
    TextStyle,
    Page,
    Modal,
    FormLayout,
    TextField,
    Banner,
} from '@shopify/polaris';
import HttpClient from './appHttpRequests';

function UsersListComponent() {
    const [users, setUsers] = useState(window.TENANT_USERS);
    const [currentUser, setCurrentUser] = useState(null);
    const [isUserModalVisible, setUserModalVisible] = useState(false);
    const [isUserRemovalModalVisible, setUserRemovalModalVisible] = useState(false);
    // console.log(users);

    const showUserModal = useCallback((user) => {
        setCurrentUser(user);
        setUserModalVisible(true);
    }, []);

    const addNewUser = useCallback(() => {
        setCurrentUser({...currentUser, isInProgress: true});
        HttpClient.post(window.SHOPIFY_APP_API_URL + '/user/add', {
            name: currentUser.name
        })
            .then((response) => {
                if (response.status === 200) {
                    setUsers([...users, {
                        name: currentUser.name,
                        api_key: response.data.api_key,
                        auth_code: response.data.auth_code
                    }]);
                    setUserModalVisible(false);
                } else {
                    setCurrentUser({...currentUser, errorText: response.statusText});
                }
            })
            .catch((error) => {
                setCurrentUser({...currentUser, errorText: (error.response && error.response.data && error.response.data.length < 64
                    ? error.response.data : (error.response && error.response.statusText ? error.response.statusText : 'Unknown error'))});
            })
            .finally(() => setCurrentUser({...currentUser, isInProgress: false}));
    }, [currentUser]);

    const modifyUser = useCallback(() => {
        setCurrentUser({...currentUser, isInProgress: true});
        HttpClient.post(window.SHOPIFY_APP_API_URL + '/user/modify', {
            api_key: currentUser.api_key,
            name: currentUser.name
        })
            .then((response) => {
                if (response.status === 200) {
                    let new_users = [...users];
                    for (let i=0; i < new_users.length; i++)
                    {
                        if (new_users[i].api_key === currentUser.api_key)
                        {
                            new_users[i].name = currentUser.name;
                            break;
                        }
                    }
                    setUsers(new_users);
                    setUserModalVisible(false);
                } else {
                    setCurrentUser({...currentUser, errorText: response.statusText});
                }
            })
            .catch((error) => {
                setCurrentUser({...currentUser, errorText: (error.response && error.response.data && error.response.data.length < 64
                        ? error.response.data : (error.response && error.response.statusText ? error.response.statusText : 'Unknown error'))});
            })
            .finally(() => setCurrentUser({...currentUser, isInProgress: false}));
    }, [currentUser]);

    const removeUser = useCallback(() => {
        setCurrentUser({...currentUser, isInProgress: true});
        HttpClient.post(window.SHOPIFY_APP_API_URL + '/user/remove', {
            api_key: currentUser.api_key
        })
            .then((response) => {
                if (response.status === 200) {
                    let new_users = [...users];
                    for (let i=0; i < new_users.length; i++)
                    {
                        if (new_users[i].api_key === currentUser.api_key)
                        {
                            new_users.splice(i, 1);
                            break;
                        }
                    }
                    setUsers(new_users);
                    setUserRemovalModalVisible(false);
                } else {
                    setCurrentUser({...currentUser, errorText: response.statusText});
                }
            })
            .catch((error) => {
                setCurrentUser({...currentUser, errorText: (error.response && error.response.data && error.response.data.length < 64
                        ? error.response.data : (error.response && error.response.statusText ? error.response.statusText : 'Unknown error'))});
            })
            .finally(() => setCurrentUser({...currentUser, isInProgress: false}));
    }, [currentUser]);

    return (
        <Page title="Packman User List">
            <Card
                actions={[{content:'Add user', onAction: () => showUserModal(null)}]}
            >
                <ResourceList
                    resourceName={{singular: 'user', plural: 'users'}}
                    items={users}
                    renderItem={(item) => {
                        const media = <Avatar customer size="medium" name={item.name} />;
                        const shortcutActions = [
                            {
                                content: 'Edit',
                                onClick: () => showUserModal(item)
                            },
                            {
                                content: 'Delete',
                                onClick: () => {setCurrentUser(item);setUserRemovalModalVisible(true)}
                            },

                        ];
                        return (
                            <ResourceItem
                                id={item.api_key}
                                media={media}
                                shortcutActions={shortcutActions}
                            >
                                <h3>
                                    <TextStyle variation="strong">{item.name}</TextStyle>
                                </h3>
                                {item.registered_at && item.device_name ? (
                                    <div>{item.device_name}</div>
                                ) : (
                                    <div>Auth Code: <b>{item.auth_code}</b></div>
                                )}

                            </ResourceItem>
                        );
                    }}
                />
            </Card>
            <div style={{height: '500px'}}>
                <Modal
                    open={isUserModalVisible}
                    onClose={() => setUserModalVisible(false)}
                    title={currentUser && currentUser.api_key ? 'Edit user' : 'Add new user'}
                    primaryAction={{
                        content: currentUser && currentUser.api_key ? 'Modify user' : 'Add user',
                        onAction: currentUser && currentUser.api_key ? modifyUser : addNewUser,
                        disabled: currentUser && currentUser.isInProgress,
                    }}
                    secondaryActions={[
                        {
                            content: 'Cancel',
                            onAction: () => setUserModalVisible(false),
                        },
                    ]}
                >
                    <Modal.Section>
                        <FormLayout>
                            <TextField label="User Name" onChange={(new_value) => setCurrentUser({...currentUser, name: new_value})} value={currentUser ? currentUser.name : ''} />
                        </FormLayout>
                        {(currentUser && currentUser.errorText && currentUser.errorText.length > 0) ? (
                            <Banner
                                title="Error"
                                status="critical"
                            >
                                <p>{currentUser.errorText}</p>
                            </Banner>
                        ) : null}
                    </Modal.Section>
                </Modal>
            </div>
            {isUserRemovalModalVisible ? (
            <div style={{height: '300px'}}>
                <Modal
                    open={isUserRemovalModalVisible}
                    onClose={() => setUserRemovalModalVisible(false)}
                    title="Remove user"
                    primaryAction={{
                        content: 'Remove user',
                        onAction: removeUser,
                        disabled: currentUser && currentUser.isInProgress,
                    }}
                    secondaryActions={[
                        {
                            content: 'Cancel',
                            onAction: () => setUserRemovalModalVisible(false),
                        },
                    ]}
                >
                    <Modal.Section>
                        <p>Are you sure you want to remove user {currentUser.name}?</p>
                        {(currentUser && currentUser.errorText && currentUser.errorText.length > 0) ? (
                            <Banner
                                title="Error"
                                status="critical"
                            >
                                <p>{currentUser.errorText}</p>
                            </Banner>
                        ) : null}
                    </Modal.Section>
                </Modal>
            </div>
                ) : null}
        </Page>
    );
}

export default function App() {
    return (
        <UsersListComponent />
    );
}

